import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Partner_Service_URL } from "../Url";

export const saveDeactivatePartnerActions = {
  SAVE_DEACTIVE_PARTNER_DETAILS_SUCCESS:
    "SAVE_DEACTIVE_PARTNER_DETAILS_SUCCESS",
  SAVE_DEACTIVE_PARTNER_DETAILS_ERROR: "SAVE_DEACTIVE_PARTNER_DETAILS_ERROR",
};

export function saveDeactivePartnerDetails(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/deletePartnerByPartnerFirmId`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveDeactivePartnerSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveDeactivePartnerError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveDeactivePartnerError(err));
          return err.response;
        }
      });
}

export function saveDeactivePartnerError(error) {
  return {
    type: saveDeactivatePartnerActions.SAVE_DEACTIVE_PARTNER_DETAILS_ERROR,
    payload: error,
  };
}

export function saveDeactivePartnerSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveDeactivatePartnerActions.SAVE_DEACTIVE_PARTNER_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
